import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import Shared from 'screens/shared';
import { getAssets } from 'themes/assets';
import { capitalize, downloadFile } from 'utils';
import { service } from 'services';
import { Paper } from '@mui/material';
import { Redirect } from 'react-router-dom';
import CreateForm from 'screens/kubernetes/clusters/create';
import { ROUTE, K8S_CLUSTER_STATE } from 'constant';
import NodePools from './nodepools';

export default ({ match = {}, history }) => {
  const { params = {} } = match;
  const { id = '' } = params;

  const assets = getAssets();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [, successes] = Shared.hooks.useNotification({
    actions: [ACTIONS_TYPES.KUBERNETES.CLUSTER.DELETE],
  });

  const { cluster = {} } = useSelector((e) => e);
  const { entities = {}, properties = {}, metadata = {} } = cluster;
  const { nodepools = {} } = entities;
  const { state = '' } = metadata;
  const {
    name = '', k8sVersion, maintenanceWindow = {},
  } = properties;
  const { dayOfTheWeek, time } = maintenanceWindow;
  const { items = [] } = nodepools;
  const isActive = state === K8S_CLUSTER_STATE.ACTIVE;

  useEffect(() => {
    actions.kubernetes.cluster.get({ id });
  }, [id]);

  useEffect(() => {
    actions.common.setLayoutTitle({
      layout: { title: 'Cluster', menu: ROUTE.DASHBOARD.KUBERNETES.key },
    });
  }, []);

  const downloadHandler = () => {
    service.kubernetes.cluster.getKubeConfigFile({ id }).then((content) => {
      downloadFile({ filename: 'kubeconfig.yaml', type: 'text/yaml', content });
    });
  };

  const onDelete = (isDelete) => {
    setShowConfirmDialog(false);
    if (isDelete) {
      actions.kubernetes.cluster.delete({ id });
    }
  };

  return (
    <div className="screen-server">
      <div className="strap">
        <div className="strap-details">
          <img src={assets.KubernatesLogo} alt="Kubernetes logo" style={{ width: 35 }} />
          <div>
            <span style={{ display: 'block', marginLeft: 5 }} className="strap-details-title">
              {name}
              <Shared.utilities.Separator />
              {k8sVersion}
            </span>
            <span style={{ display: 'flex', justifyItems: 'center', marginLeft: 5 }}>
              <Shared.utilities.StatusLED state={state} />
              <span style={{ marginLeft: 3, fontSize: 12 }}>
                {capitalize(state)}
                <Shared.utilities.Separator />
                <Shared.widgets.Icon name="clock" style={{ color: '#707070' }} />
                {' '}
                {time}
                <Shared.utilities.Separator />
                <Shared.widgets.Icon name="calendar-day" style={{ color: '#707070' }} />
                {' '}
                {dayOfTheWeek}
              </span>
            </span>
          </div>
        </div>

        {isActive ? (
          <div className="strap-details-icons">
            <Shared.widgets.Icon
              name="trash"
              onClick={() => setShowConfirmDialog(true)}
              style={{ color: 'var(--color-danger)', marginRight: 4 }}
            />
            <Shared.widgets.Icon
              name="edit"
              onClick={() => setIsUpdate(!isUpdate)}
            />
            <Shared.widgets.Icon
              name="download"
              title="Kubeconfig.yaml"
              onClick={downloadHandler}
            />
          </div>
        ) : (
          <div>
            <Shared.widgets.Loader isInline show size={22} />
          </div>
        )}
      </div>

      {isUpdate && (
        <Paper>
          <CreateForm
            isCancel
            onCancel={() => setIsUpdate(false)}
            cluster={cluster}
          />
        </Paper>
      )}

      <NodePools isActive={isActive} nodepools={items} clusterId={id} history={history} />

      <Shared.dialog.Confirm show={showConfirmDialog} onClose={onDelete} />
      {!!successes.length && <Redirect to="/kubernetes" />}
    </div>
  );
};
